import React from "react";
import { Helmet } from "react-helmet-async";
import AllianceOfferInfo from "../../../components/desktop/alliance-offer-info";
import withMarketingLayout from "../../../components/desktop/marketing-layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";

const AllianceOffer = () => {
    return (
        <React.Fragment>
            <Helmet>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
            </Helmet>
            <ErrorHandler>
                <AllianceOfferInfo/>
            </ErrorHandler>
        </React.Fragment>
    );
};
export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(withMarketingLayout(AllianceOffer));
